var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "upload",
      attrs: { "element-loading-text": "正在努力上传中..." },
    },
    [
      _c("h2", { staticClass: "uploadTitle" }, [_vm._v("上传答案")]),
      _c("img", {
        staticClass: "uploadIcon",
        attrs: { src: require("./image/zengzaikaoshi.png"), alt: "" },
      }),
      _vm.isShow
        ? _c("img", {
            staticClass: "uploadButton",
            attrs: { src: require("./image/zhaoxiang.png"), alt: "" },
          })
        : _vm._e(),
      _vm.isShow
        ? _c("p", { staticStyle: { "font-size": "14px", color: "#999" } }, [
            _vm._v(" 你已上传成功，再上传请重新扫码 "),
          ])
        : _vm._e(),
      _c("img", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isShow,
            expression: "!isShow",
          },
        ],
        staticClass: "uploadButton",
        attrs: { src: require("./image/zhaoxiang.png"), alt: "" },
        on: { click: _vm.isOpen },
      }),
      _vm.imgData.length > 0
        ? _c(
            "div",
            _vm._l(_vm.imgData, function (item, index) {
              return _c("img", {
                key: index,
                staticClass: "imgData",
                attrs: { src: item, alt: "" },
              })
            }),
            0
          )
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            modal: false,
            "show-close": false,
            direction: _vm.direction,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("ul", { staticClass: "chooseUpdata" }, [
            _c("li", [
              _vm._v(" 拍照上传 "),
              _c("input", {
                staticClass: "input",
                attrs: {
                  type: "file",
                  accept: "image/*",
                  capture: "camera",
                  value: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.isUpData($event)
                  },
                },
              }),
            ]),
            _c("li", [
              _vm._v(" 从手机相册选择 "),
              _c("input", {
                staticClass: "input",
                attrs: {
                  type: "file",
                  accept: "image/*",
                  value: "",
                  multiple: "",
                },
                on: {
                  change: function ($event) {
                    return _vm.isUpData($event)
                  },
                },
              }),
            ]),
            _c(
              "li",
              {
                on: {
                  click: function ($event) {
                    _vm.drawer = false
                  },
                },
              },
              [_vm._v("取消")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }